import { ChangeDetectionStrategy, Component, computed, contentChildren, input, model } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";
import { StepComponent } from "./step.component";
import { findIndex, findLastIndex } from "lodash";

export type StepperVariant = "discrete" | "continuous-bar" | "continuous-dot";

@Component({
    selector: "app-stepper",
    templateUrl: "./stepper.component.html",
    styleUrls: ["./stepper.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet]
})
export class StepperComponent {
    variant = input<StepperVariant>("discrete");
    disableStepSelection = input<boolean>(false);
    steps = contentChildren(StepComponent);
    selectedIndex = model<number>(0);

    selected = computed(() => {
        const steps = this.steps();
        return steps.length ? steps[this.selectedIndex()] : undefined;
    });

    _isValidIndex(index: number): boolean {
        return index < this.steps().length && index > -1;
    }

    next(): void {
        const newIndex = findIndex(this.steps(), step => !step.disabled(), this.selectedIndex() + 1);
        if (newIndex !== -1) {
            this.selectedIndex.set(newIndex);
        }
    }

    previous(): void {
        const newIndex = findLastIndex(this.steps().slice(0, this.selectedIndex()), step => !step.disabled());
        if (newIndex !== -1) {
            this.selectedIndex.set(newIndex);
        }
    }

    select(step: StepComponent) {
        if (this.disableStepSelection()) return;
        const index = this.steps().indexOf(step);
        if (index !== -1 && this._isValidIndex(index)) {
            this.selectedIndex.set(index);
        }
    }
}
